module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.24605",
      "conversations-internal-schema": "static-1.12002",
      "head-dlb": "static-1.4360",
      "hs-test-utils": "static-1.7347",
      "hubspot-url-utils": "static-1.3567",
      "HubStyleTokens": "static-2.10870",
      "I18n": "static-7.1452",
      "jasmine-runner": "static-1.5774",
      "quartz": "static-1.6167",
      "react": "static-7.151",
      "sinon": "static-1.9",
      "webpack-env": "static-1.54",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.476",
      "visitor-ui-component-library": "static-1.5514",
      "enviro": "static-4.328",
      "hs-promise-rejection-tracking": "static-1.4750",
      "PortalIdParser": "static-2.306",
      "raven": "static-3.5229",
      "raven-hubspot": "static-1.5536",
      "bend-plugin-trellis-migration": "static-1.2887",
      "moment": "static-3.26",
      "cv-backend-services": "static-1.1341",
      "hub-http": "static-1.5499",
      "immutable": "static-2.19",
      "immutable-less": "static-1.3914",
      "quartz-core": "static-1.5386",
      "transmute": "static-2.77",
      "HeadJS": "static-2.623",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.6864",
      "framer-motion": "static-1.53",
      "hs-test-utils-bend-plugin": "static-1.2458",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.135",
      "foundations-theming": "static-1.3697",
      "i18n-data": "static-1.208",
      "metrics-js": "static-1.9110",
      "moment-timezone": "static-5.68",
      "react-utils": "static-2.4741",
      "jasmine": "static-4.3664",
      "quartz-core-utils": "static-1.3034",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.44",
      "styled-components": "static-2.64",
      "UIComponents": "static-3.7817",
      "visitor-ui-component-library-icons": "static-1.5325",
      "rpc-client-utils": "static-1.4051",
      "ts-schema": "static-1.3530",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.122",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.699",
      "hub-http-shared-msw-handlers": "static-1.8462",
      "hubspotter-http": "static-1.4002",
      "hubspotter-http-shared-msw-handlers": "static-1.8460",
      "icons": "static-2.596",
      "mobile-manifest-mixins": "static-1.395",
      "platform-navigation-bootstrap": "static-1.11864",
      "quick-fetch": "static-1.2772",
      "react-rhumb": "static-1.15958",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.334",
      "bend-plugin-foundations-components": "static-1.3133",
      "floating-ui": "static-1.41",
      "foundations-assets": "static-1.4212",
      "foundations-theming-specialty": "static-1.1413",
      "hs-story-utils": "static-1.8720",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.82",
      "tanstack-table": "static-1.23",
      "ui-images": "static-2.967",
      "bend-plugin-foundations-theming": "static-1.2180",
      "foundations-theming-base": "static-1.2682",
      "classnames": "static-2.10",
      "cssUtils": "static-1.602",
      "HubStyle": "static-2.11178",
      "sassPrefix": "static-1.142",
      "platform-infra-nav-components": "static-1.7112",
      "react-input-autosize": "static-2.17"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.24605",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12002",
      "head-dlb": "/head-dlb/static-1.4360",
      "hs-test-utils": "/hs-test-utils/static-1.7347",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3567",
      "HubStyleTokens": "/HubStyleTokens/static-2.10870",
      "I18n": "/I18n/static-7.1452",
      "jasmine-runner": "/jasmine-runner/static-1.5774",
      "quartz": "/quartz/static-1.6167",
      "react": "/react/static-7.151",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.54",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.476",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5514",
      "enviro": "/enviro/static-4.328",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4750",
      "PortalIdParser": "/PortalIdParser/static-2.306",
      "raven": "/raven/static-3.5229",
      "raven-hubspot": "/raven-hubspot/static-1.5536",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2887",
      "moment": "/moment/static-3.26",
      "cv-backend-services": "/cv-backend-services/static-1.1341",
      "hub-http": "/hub-http/static-1.5499",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.3914",
      "quartz-core": "/quartz-core/static-1.5386",
      "transmute": "/transmute/static-2.77",
      "HeadJS": "/HeadJS/static-2.623",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.6864",
      "framer-motion": "/framer-motion/static-1.53",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2458",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.135",
      "foundations-theming": "/foundations-theming/static-1.3697",
      "i18n-data": "/i18n-data/static-1.208",
      "metrics-js": "/metrics-js/static-1.9110",
      "moment-timezone": "/moment-timezone/static-5.68",
      "react-utils": "/react-utils/static-2.4741",
      "jasmine": "/jasmine/static-4.3664",
      "quartz-core-utils": "/quartz-core-utils/static-1.3034",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.44",
      "styled-components": "/styled-components/static-2.64",
      "UIComponents": "/UIComponents/static-3.7817",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5325",
      "rpc-client-utils": "/rpc-client-utils/static-1.4051",
      "ts-schema": "/ts-schema/static-1.3530",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.122",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.699",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8462",
      "hubspotter-http": "/hubspotter-http/static-1.4002",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8460",
      "icons": "/icons/static-2.596",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.395",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11864",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-rhumb": "/react-rhumb/static-1.15958",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.334",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3133",
      "floating-ui": "/floating-ui/static-1.41",
      "foundations-assets": "/foundations-assets/static-1.4212",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1413",
      "hs-story-utils": "/hs-story-utils/static-1.8720",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.82",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-images": "/ui-images/static-2.967",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2180",
      "foundations-theming-base": "/foundations-theming-base/static-1.2682",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.602",
      "HubStyle": "/HubStyle/static-2.11178",
      "sassPrefix": "/sassPrefix/static-1.142",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7112",
      "react-input-autosize": "/react-input-autosize/static-2.17"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};